import { supabase } from './supabase'

export function hasSignedDocument(doc) {
  return Boolean(doc?.signed_file_path) && !['pending', 'partial'].includes(doc.signing_status)
}

export function signedDocumentUnavailable(doc) {
  return !hasSignedDocument(doc) && (doc?.signing_status === 'complete' || doc?.status === 'signed')
}

export async function downloadDocument(doc, variant = 'signed') {
  if (!['signed', 'original'].includes(variant)) throw new Error('Choose a document copy to download.')
  const signed = variant === 'signed'
  if (signed && !hasSignedDocument(doc)) {
    throw new Error('The signed PDF is not available. Complete all required signatures or ask your firm to review this document.')
  }
  const filePath = signed ? doc.signed_file_path : doc?.file_path
  if (!filePath) throw new Error('This document file is unavailable.')

  // The authenticated storage request preserves the existing firm/client access rules.
  const { data, error } = await supabase.storage.from('client-documents').download(filePath)
  if (error || !data || data.size === 0) {
    throw new Error(`Could not download the ${signed ? 'signed PDF' : 'original document'}. Please try again.`)
  }

  const safeName = (doc.file_name || 'document.pdf').replace(/[\\/:*?"<>|\u0000-\u001f]/g, '_').trim() || 'document.pdf'
  const filename = signed ? `${safeName.replace(/\.pdf$/i, '')}-signed.pdf` : safeName
  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  try { link.click() }
  finally {
    link.remove()
    // Allow the browser to start reading the blob before releasing it.
    setTimeout(() => URL.revokeObjectURL(url), 60000)
  }
  return { variant, filename }
}
